<header mat-dialog-title class="u-flex-full">
  <span>
    <span *ngIf="target">{{'risks.Modifica obiettivo' | translate}} : {{target.name}}</span>
    <span *ngIf="!target">{{'risks.Nuovo obiettivo' | translate}}</span>
  </span>
  <span *ngIf="target">
    <button mat-icon-button [mat-menu-trigger-for]="actionMenu">
      <mat-icon>more_vert</mat-icon>
    </button>
    <mat-menu x-position="before" overlapTrigger="false" #actionMenu="matMenu">
      <button mat-menu-item (click)="deleteTarget()">
        <mat-icon>delete</mat-icon>
        {{'shared.Elimina' | translate}}
      </button>
    </mat-menu>
  </span>
</header>
<mat-dialog-content>
  <form [formGroup]="targetForm" novalidate>
    <div class="u-flex-full">
    <mat-form-field class="u-full-width">
      <input matInput placeholder="{{'shared.Nome' | translate}}" formControlName="name" type="text" >
      <mat-error>{{'shared.Campo obbligatorio' | translate}}</mat-error>
    </mat-form-field>
     </div>
  </form>
    <!-- {{targetForm.value | json}} -->

</mat-dialog-content>
<mat-dialog-actions class="u-flex-full">
  <span>
    <button mat-raised-button color="basic" type="reset" (click)="revert()"
      [disabled]="targetForm.pristine">{{'shared.Reset' | translate}}</button>
    <button mat-raised-button color="primary" (click)="save()"
      [disabled]="targetForm.pristine || !targetForm.valid">{{'shared.Salva' | translate}}</button>
    <span class="fill-remaining"></span>
  </span>
  <button mat-raised-button color="basic" type="button" (click)="close()">{{'shared.Chiudi' | translate}}</button>
</mat-dialog-actions>
